import settingTypes from "./setting.types";
export default {
  fetchSettingLoading: state =>
    state.type === settingTypes.FETCH_SETTING_REQUEST,
  fetchSettingSuccess: state =>
    state.type === settingTypes.FETCH_SETTING_SUCCESS,
  fetchSettingFailed: state =>
    state.type === settingTypes.FETCH_SETTING_FAILED,

  updateSettingLoading: state =>
    state.type === settingTypes.UPDATE_SETTING_REQUEST,
  updateSettingSuccess: state =>
    state.type === settingTypes.UPDATE_SETTING_SUCCESS,
  updateSettingFailed: state =>
    state.type === settingTypes.UPDATE_SETTING_FAILED,

  deleteSettingLoading: state =>
    state.type === settingTypes.DELETE_SETTING_REQUEST,
  deleteSettingSuccess: state =>
    state.type === settingTypes.DELETE_SETTING_SUCCESS,
  deleteSettingFailed: state =>
    state.type === settingTypes.DELETE_SETTING_FAILED,

  addEmployeeLoading: state =>
    state.type === settingTypes.ADD_EMPLOYEE_REQUEST,
  addEmployeeSuccess: state =>
    state.type === settingTypes.ADD_EMPLOYEE_SUCCESS,
  addEmployeeFailed: state =>
    state.type === settingTypes.ADD_EMPLOYEE_FAILED,
};
